import { cn } from '@repo/ui/lib/utils'
import React from 'react'
import { cva, VariantProps } from 'class-variance-authority'
import { Surface } from './Surface'

// Atom for a page container with a padding, gap, and maxWidth

export type PageContainerProps = {
  as?: React.ElementType
} & React.ComponentPropsWithoutRef<React.ElementType> &
  VariantProps<typeof pageContainerVariants>

const pageContainerVariants = cva('', {
  variants: {
    padding: {
      none: 'p-0',
      xs: 'p-2',
      sm: 'p-4',
      md: 'p-8',
      lg: 'p-12',
    },
    gap: {
      none: 'space-y-0',
      xs: 'space-y-2',
      sm: 'space-y-4',
      md: 'space-y-8',
      lg: 'space-y-12',
    },
    maxWidth: {
      none: '',
      narrow: 'max-w-4xl mx-auto',
      default: 'max-w-[1184px] mx-auto', //full width for 1440px screens
      wide: 'max-w-[1664px] mx-auto', //full width for 1920px screens
    },
  },
  defaultVariants: {
    padding: 'md',
    gap: 'md',
    maxWidth: 'default',
  },
})

export function PageContainer(props: PageContainerProps) {
  const { padding, gap, maxWidth, className, ...rest } = props

  return (
    <Surface
      tone="level-2"
      border={false}
      radius="none"
      padding="none"
      className={cn(
        pageContainerVariants({
          padding,
          gap,
          maxWidth,
        }),
        className,
      )}
      {...rest}
    />
  )
}
